import { SVGProps } from 'react'

export const Agents = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.91266 7.30582C6.4349 5.01212 9.04086 3.5 12 3.5C15.7065 3.5 18.859 5.87242 20.0216 9.1816C18.8926 9.32743 17.7242 9.96052 16.6096 10.7129C15.7776 11.2746 14.9071 11.9526 14.0328 12.6491C13.5163 12.2579 12.9943 11.8418 12.4609 11.4146L12.3499 11.3257C10.166 9.57617 7.76736 7.65459 4.91266 7.30582ZM4.14275 8.75169C3.72856 9.75245 3.5 10.8495 3.5 12C3.5 14.0092 4.19709 15.8555 5.36259 17.3104C6.28412 17.4735 7.34659 17.203 8.56248 16.5749C9.85232 15.9085 11.2008 14.8999 12.5753 13.8123C12.6578 13.747 12.7405 13.6814 12.8233 13.6155C12.4149 13.2997 12.015 12.9793 11.6222 12.6646L11.6221 12.6646L11.5233 12.5854C9.01554 10.5771 6.7687 8.81366 4.14275 8.75169ZM6.85885 18.7695C8.28646 19.8554 10.068 20.5 12 20.5C14.959 20.5 17.5649 18.988 19.0871 16.6945C17.247 16.471 15.597 15.5978 14.0728 14.5377C13.8855 14.6874 13.6965 14.8379 13.506 14.9886C12.1316 16.0762 10.6828 17.1678 9.251 17.9075C8.47548 18.3082 7.67059 18.6239 6.85885 18.7695ZM19.8572 15.2483C20.2714 14.2476 20.5 13.1505 20.5 12C20.5 11.5415 20.4637 11.0915 20.3938 10.6527C19.6253 10.6917 18.6479 11.1468 17.4489 11.9562C16.7585 12.4222 16.0433 12.9703 15.302 13.5568C16.7741 14.5352 18.2438 15.2105 19.8572 15.2483ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z"
      fill="currentColor"
    />
  </svg>
)
